/// <reference types="node" />
import {
    ENVIRONMENT
    // @ts-expect-error - environment variable injected by babel
} from "@env";

export let THREET_SOCKET_SERVER_ADDRESS = process.env.THREET_SOCKET_SERVER_ADDRESS ? process.env.THREET_SOCKET_SERVER_ADDRESS : "wss://threet.gencmusiadkonya.org";
export let SERVER_ADDRESS = process.env.SERVER_ADDRESS ? process.env.SERVER_ADDRESS : "https://api.gencmusiadkonya.org";

export const SERVER_ADDRESS_VERSION_JSON = ENVIRONMENT === "development" ? "" : "https://api.gencmusiadkonya.org";

export const SHARE_ADRESS = ENVIRONMENT === "production" ? "https://app.gencmusiadkonya.org" : "https://share-dev.gencmusiadkonya.org";

export const SERVER_ADDRESS_STORAGE = process.env.REACT_APP_SERVER_ADDRESS_STORAGE
    ? process.env.REACT_APP_SERVER_ADDRESS_STORAGE
    : "https://storage.gencmusiadkonya.org";
if (!process.env.SERVER_ADDRESS) {
    if (ENVIRONMENT === "development") {
        SERVER_ADDRESS = "http://192.168.1.102:81";
        THREET_SOCKET_SERVER_ADDRESS = "ws://192.168.1.101:3001";
    }

    if (ENVIRONMENT === "production") {
        SERVER_ADDRESS = "https://api.gencmusiadkonya.org";
        THREET_SOCKET_SERVER_ADDRESS = "wss://threet.gencmusiadkonya.org";
    }

    if (ENVIRONMENT === "custom") {
        console.log("production", ENVIRONMENT);
        THREET_SOCKET_SERVER_ADDRESS = "ws://192.168.1.101:3001";
    }
}
